import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconNorwayComponent = ({ ...rest }) => {
  return (
    <SvgIcon {...rest}>
      <svg
        fill="none"
        height="60"
        viewBox="0 0 80 60"
        width="80"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path d="M0 0H80V60H0V0Z" fill="#ED2939" />
          <path d="M22.5 0H37.5V60H22.5V0Z" fill="white" />
          <path d="M0 22.5H80V37.5H0V22.5Z" fill="white" />
          <path d="M26.25 0H33.75V60H26.25V0Z" fill="#002664" />
          <path d="M0 26.25H80V33.75H0V26.25Z" fill="#002664" />
        </g>
        <defs>
          <clipPath id="clip0_3012_1338">
            <rect fill="white" height="60" rx="8" width="80" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

IconNorwayComponent.displayName = 'IconNorway';

const IconNorway = memo(IconNorwayComponent);

export default IconNorway;
